'use client';

import Icon from './Icon';
import svg from 'sprites/share-link.svg';

export default function IconShareLink({
  className = 'w-3.5 h-3 fill-none stroke-brown'
}: {
  className?: string;
}) {
  return <Icon id={svg.id} className={className} />;
}
